var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconEmail = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F2BD00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1603_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1603_10375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9L29.55 14.4C29.85 14.5833 30.0833 14.8333 30.25 15.15C30.4167 15.4667 30.5 15.8 30.5 16.15V27C30.5 27.55 30.3042 28.0208 29.9125 28.4125C29.5208 28.8042 29.05 29 28.5 29H12.5C11.95 29 11.4792 28.8042 11.0875 28.4125C10.6958 28.0208 10.5 27.55 10.5 27V16.15C10.5 15.8 10.5833 15.4667 10.75 15.15C10.9167 14.8333 11.15 14.5833 11.45 14.4L20.5 9ZM20.5 20.65L28.3 16L20.5 11.35L12.7 16L20.5 20.65ZM20.5 23L12.5 18.2V27H28.5V18.2L20.5 23Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-email.999c0358.svg";
export { ForwardRef as ReactComponent };